import { Routes } from '@angular/router';
import { AppLayoutComponent } from './shared/components/app-layout/app-layout.component';
import { StepActivationGuard } from './shared/guards/step-activation.guard';
import {
  INFORMATION_PATH,
  TYPE_BREED_PATH,
  IDENTIFICATION_PATH,
  VACCINES_PATH,
  MEDICAL_HISTORY_PATH,
  COVER_LEVEL_PATH,
  SUBSCRIBER_PATH,
  OFFER_CUSTOMIZE_PATH,
  QUOTE_CONFIRMATION_PATH,
  DIRECT_DEBIT_PATH,
  SPECIAL_CONDITIONS_PATH,
  CONFIRMATION_PATH,
  CONTRACT_VALIDATION_PATH,
  ROOT_PATH,
  SUBSCRIPTION_PATH,
  CONTEXT_PATH,
  PRODUCT_PATH,
  START_CONTEXT_PATH,
  START_CONTEXT_PRODUCT_PATH,
  SIGNATURE_STATUS_PATH,
  E_SIGN_MSG_STATUS_PATH,
  CROSS_SELLING_W_PATH,
  CROSS_SELLING_C_PATH,
  ERROR_PATH,
  ERROR_EMAIL_PATH
} from './shared/constants/route.constants';
import { ProductGuard } from './shared/guards/product.guard';
import { ContextGuard } from './shared/guards/context.guard';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import { CrossSellingComponent } from './views/process/options/cross-selling/cross-selling.component';
import { RedirectGuard } from './shared/guards/redirect.guard';
import { environment } from 'src/environments/environment';
import { StartGuard } from './shared/guards/start.guard';
import { ESignMsgComponent } from './views/process/options/e-sign-msg/e-sign-msg.component';
import { ErrorComponent } from './shared/components/error/error.component';

export const route_animal_health: Routes = [
  {
    path: INFORMATION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/information/information.component'
      ).then(m => m.InformationComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: TYPE_BREED_PATH,
    loadComponent: () =>
      import('./views/process/options/type-breed/type-breed.component').then(
        m => m.TypeBreedComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: IDENTIFICATION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/identification/identification.component'
      ).then(m => m.IdentificationComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: VACCINES_PATH,
    loadComponent: () =>
      import('./views/process/options/vaccines/vaccines.component').then(
        m => m.VaccinesComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: MEDICAL_HISTORY_PATH,
    loadComponent: () =>
      import(
        './views/process/options/medical-history/medical-history.component'
      ).then(m => m.MedicalHistoryComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: COVER_LEVEL_PATH,
    loadComponent: () =>
      import(
        './views/process/options/cover-level/cover-level.component'
      ).then(m => m.CoverLevelComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: SUBSCRIBER_PATH,
    loadComponent: () =>
      import('./views/process/options/subscriber/subscriber.component').then(
        m => m.SubscriberComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: OFFER_CUSTOMIZE_PATH,
    loadComponent: () =>
      import(
        './views/process/options/offer-customize/offer-customize.component'
      ).then(m => m.OfferCustomizeComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: QUOTE_CONFIRMATION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/quote-confirmation/quote-confirmation.component'
      ).then(m => m.QuoteConfirmationComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: DIRECT_DEBIT_PATH,
    loadComponent: () =>
      import('./views/process/options/direct-debit/direct-debit.component').then(
        m => m.DirectDebitComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: SPECIAL_CONDITIONS_PATH,
    loadComponent: () =>
      import(
        './views/process/options/special-conditions/special-conditions.component'
      ).then(m => m.SpecialConditionsComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: CONFIRMATION_PATH,
    loadComponent: () =>
      import('./views/process/options/confirmation/confirmation.component').then(
        m => m.ConfirmationComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: CROSS_SELLING_W_PATH,
    loadComponent: () =>
      import('./views/process/options/cross-selling/cross-selling.component').then(
        m => m.CrossSellingComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: CROSS_SELLING_C_PATH, // Requires to have two different paths to differentiate W and C channels steps
    loadComponent: () =>
      import('./views/process/options/cross-selling/cross-selling.component').then(
        m => m.CrossSellingComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: CONTRACT_VALIDATION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/contract-validation/contract-validation.component'
      ).then(m => m.ContractValidationComponent),
    canActivate: [StepActivationGuard]
  }
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'product/' + environment.product,
    pathMatch: 'full'
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: SUBSCRIPTION_PATH,
        loadComponent: () =>
          import('./views/process/subscription/subscription.component').then(
            m => m.SubscriptionComponent
          ),
        children: route_animal_health
      },
      {
        path: START_CONTEXT_PRODUCT_PATH,
        canActivate: [RedirectGuard],
        component: RedirectComponent
      },
      {
        path: START_CONTEXT_PATH,
        canActivate: [RedirectGuard],
        component: RedirectComponent
      },
      {
        path: CONTEXT_PATH,
        canActivate: [ContextGuard],
        component: RedirectComponent
      },
      {
        path: PRODUCT_PATH,
        canActivate: [ProductGuard],
        component: RedirectComponent
      },
      {
        path: SIGNATURE_STATUS_PATH,
        canActivate: [StartGuard],
        component: RedirectComponent
      },
      {
        path: CROSS_SELLING_C_PATH,
        component: CrossSellingComponent
      },
      {
        path: E_SIGN_MSG_STATUS_PATH,
        component: ESignMsgComponent
      },
      {
        path: ERROR_PATH,
        component: ErrorComponent
      },
      {
        path: ERROR_EMAIL_PATH,
        component: ErrorComponent,
        data: {
          title: 'Attention',
          message: 'Une adresse email est nécessaire pour accéder à ce parcours. Merci de la renseigner.'
        }
      },
      {
        path: '**',
        redirectTo: SUBSCRIPTION_PATH + ROOT_PATH + INFORMATION_PATH
      }
    ]
  }
];
